import { debounceTime, first, of } from "rxjs";

export function setTimeout$(cb: () => void, timer: number) {
    of(true).pipe(debounceTime(timer), first()).subscribe(cb);
  }